<rcp-modal-content>
  @for (notice of notices; track notice; let last = $last) {
    @if (currentNoticeId() === notice.id) {
      <section class="no-border no-padding-top text pre-line" [innerHTML]="notice.text"></section>
    }
  }
</rcp-modal-content>
<rcp-modal-footer>
  <rcp-button-container align="center">
    <rcp-button color="primary" (click)="nextOrClose()"> {{ 'qz-i-understand-zm' | translate }}</rcp-button>
  </rcp-button-container>
</rcp-modal-footer>
